// import Cookies from 'js-cookie';
import { updateLoginInfo2 } from '../middleware/callApi';
/**
 * 默认参数丢失，统一抛出错误
 * @param message 错误消息
 */
export function throwIfMissing(message = '关键字不能为空') {
  console.log(message);
}

export function updateLoginInfo({ token = null, userInfo }) {
  updateLoginInfo2({ token, userInfo });
}
// export function updateLoginInfo({ token = null, userInfo }) {
//   if (token) {
//     if (window.ajaxHeader) {
//       window.ajaxHeader.token = token;
//       window.ajaxHeader.encUserId = userInfo ? userInfo.encUserId : null;
//     } else {
//       window.ajaxHeader = {
//         token,
//         encUserId: userInfo ? userInfo.encUserId : null,
//       };
//     }
//   }
//   if (window.localStorage) {
//     window.localStorage.setItem('token', token);
//     if (userInfo) {
//       window.localStorage.setItem('userinfo', JSON.stringify(userInfo));
//     }
//   }
// }

export default {
  throwIfMissing
};



// WEBPACK FOOTER //
// ./src/comm/utils/index.js